import {Attribute} from '../../components/ObjectAttribute';
import {Json} from '../../components/JsonObjectCard';

export const transferOrderJsonObject: Json = {
    title: 'THE TRANSFER ORDER OBJECT',
    json: {
        'id': 1,
        'number': 'TO-00001',
        'status': 'Issued',
        'type': 'Ship',
        'fromLocationGroup': {
            'id': 1,
            'name': 'Main Warehouse'
        },
        'toLocationGroup': {
            'id': 2,
            'name': 'East Warehouse'
        },
        'carrier': {
            'id': 5,
            'name': 'USPS'
        },
        'shipFromAddress': {
            'name': 'Main Warehouse',
            'street': '100 Main St',
            'city': 'Salt Lake City',
            'state': 'UT',
            'postalCode': '84101',
            'country': 'UNITED STATES'
        },
        'shipToAddress': {
            'name': 'East Warehouse',
            'street': '200 East Blvd',
            'city': 'Denver',
            'state': 'CO',
            'postalCode': '80201',
            'country': 'UNITED STATES'
        },
        'note': '',
        'ownerIsFrom': true,
        'revisionNumber': 1,
        'lastModified': {
            'username': 'admin',
            'dateLastModified': '2024-03-01T10:00:00.000-0700'
        },
        'dateCreated': '2024-03-01T08:00:00.000-0700',
        'dateIssued': '2024-03-01T10:00:00.000-0700',
        'dateScheduled': '2024-03-05T00:00:00.000-0700',
        'toItems': [
            {
                'id': 101,
                'part': {
                    'id': 28,
                    'name': 'B201',
                    'description': 'Premium Brake Cables'
                },
                'type': {
                    'id': 10,
                    'name': 'Send'
                },
                'status': 'Entered',
                'uom': {
                    'id': 1,
                    'name': 'Each',
                    'abbreviation': 'ea'
                },
                'lineNumber': 1,
                'note': '',
                'quantity': '10',
                'quantityFulfilled': '1',
                'quantityPicked': '1',
                'unitCost': '1',
                'dateScheduled': '2024-03-05T00:00:00.000-0700'
            }
        ],
        'customFields': [
            {
                'id': 19,
                'name': 'Custom',
                'value': 'My Custom Field',
                'type': 'Text'
            }
        ]
    },
};

export const transferOrderAttributes: Attribute[] = [
    {
        name: 'id',
        type: 'integer',
        description: 'The transfer order\'s unique identification number.'
    },
    {
        name: 'number',
        type: 'string',
        description: 'The transfer order number.'
    },
    {
        name: 'status',
        type: 'string',
        description: 'The order status.'
    },
    {
        name: 'type',
        type: 'string: \'Ship\' | \'Move\' | \'Putaway\'',
        description: 'The transfer order type.'
    },
    {
        name: 'fromLocationGroup',
        type: 'reference object',
        description: 'The origin location group.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The unique identification number.',
            },
            {
                name: 'name',
                type: 'string',
                description: 'The name of the location group.',
            }
        ]
    },
    {
        name: 'toLocationGroup',
        type: 'reference object',
        description: 'The destination location group.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The unique identification number.',
            },
            {
                name: 'name',
                type: 'string',
                description: 'The name of the location group.',
            }
        ]
    },
    {
        name: 'carrier',
        type: 'reference object',
        optional: true,
        description: 'The shipping carrier.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The unique identification number.',
            },
            {
                name: 'name',
                type: 'string',
                description: 'The name of the carrier.',
            },
            {
                name: 'service',
                type: 'reference object',
                optional: true,
                description: 'The carrier service.',
                children: [
                    {
                        name: 'id',
                        type: 'integer',
                        description: 'The unique identification number.',
                    },
                    {
                        name: 'name',
                        type: 'string',
                        description: 'The name of the carrier service.',
                    }
                ]
            }
        ]
    },
    {
        name: 'shipFromAddress',
        type: 'object',
        description: 'The address the transfer originates from.',
        children: [
            { name: 'name', type: 'string', description: 'The name on the address.' },
            { name: 'street', type: 'string', description: 'The street line.' },
            { name: 'city', type: 'string', description: 'The city.' },
            { name: 'state', type: 'string', description: 'The state\'s abbreviation.' },
            { name: 'postalCode', type: 'string', description: 'The postal code.' },
            { name: 'country', type: 'string', description: 'The country.' }
        ]
    },
    {
        name: 'shipToAddress',
        type: 'object',
        description: 'The address the transfer is destined for.',
        children: [
            { name: 'name', type: 'string', description: 'The name on the address.' },
            { name: 'street', type: 'string', description: 'The street line.' },
            { name: 'city', type: 'string', description: 'The city.' },
            { name: 'state', type: 'string', description: 'The state\'s abbreviation.' },
            { name: 'postalCode', type: 'string', description: 'The postal code.' },
            { name: 'country', type: 'string', description: 'The country.' }
        ]
    },
    {
        name: 'note',
        type: 'string',
        description: 'The order\'s note field.'
    },
    {
        name: 'ownerIsFrom',
        type: 'boolean',
        description: 'Indicates whether ownership of the inventory belongs to the origin location group during the transfer.'
    },
    {
        name: 'revisionNumber',
        type: 'integer',
        description: 'The revision number.'
    },
    {
        name: 'lastModified',
        type: 'object',
        optional: true,
        description: 'Timestamp of when the order was last modified and the user that made the change.',
        children: [
            {
                name: 'username',
                type: 'string',
                description: 'The username of the user who last modified the order.',
            },
            {
                name: 'dateLastModified',
                type: 'date',
                description: 'The date last modified.',
            }
        ]
    },
    {
        name: 'dateCreated',
        type: 'date',
        description: 'Timestamp of when the order was created.'
    },
    {
        name: 'dateIssued',
        type: 'date',
        description: 'Timestamp of when the order was issued.'
    },
    {
        name: 'dateScheduled',
        type: 'date',
        description: 'Timestamp of when the order is scheduled to be fulfilled.'
    },
    {
        name: 'dateConfirmed',
        type: 'date',
        description: 'Timestamp of when the order was confirmed.'
    },
    {
        name: 'dateCompleted',
        type: 'date',
        description: 'Timestamp of when the order was completed.'
    },
    {
        name: 'toItems',
        type: 'list',
        description: 'A list of the transfer order line items.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The unique identifier for the line item.',
            },
            {
                name: 'part',
                type: 'reference object',
                description: 'The part on the line item.',
                children: [
                    { name: 'id', type: 'integer', description: 'The unique identification number.' },
                    { name: 'name', type: 'string', description: 'The part number.' },
                    { name: 'description', type: 'string', description: 'The part description.' },
                ]
            },
            {
                name: 'type',
                type: 'reference object',
                description: 'The line item type.',
                children: [
                    { name: 'id', type: 'integer', description: 'The unique identification number.' },
                    { name: 'name', type: 'string: \'Send\' | \'Receive\'', description: 'The type name.' }
                ]
            },
            {
                name: 'status',
                type: 'string',
                description: 'The status of the line item.'
            },
            {
                name: 'uom',
                type: 'reference object',
                description: 'The part unit of measure.',
                children: [
                    { name: 'id', type: 'integer', description: 'The unique identification number.' },
                    { name: 'name', type: 'string', description: 'The name of the unit of measure.' },
                    { name: 'abbreviation', type: 'string', description: 'The abbreviated name.' }
                ]
            },
            {
                name: 'lineNumber',
                type: 'integer',
                description: 'The line number for the order item.'
            },
            {
                name: 'note',
                type: 'string',
                description: 'The note on the line item.'
            },
            {
                name: 'quantity',
                type: 'quantity',
                description: 'The quantity to be transferred.'
            },
            {
                name: 'quantityFulfilled',
                type: 'quantity',
                description: 'The quantity already fulfilled.'
            },
            {
                name: 'quantityPicked',
                type: 'quantity',
                description: 'The quantity already picked.'
            },
            {
                name: 'unitCost',
                type: 'money',
                optional: true,
                description: 'The unit cost of the item. Most transfer order items have no cost since they represent inventory moved between locations. Only present when a cost applies (e.g. shipping charges).'
            },
            {
                name: 'dateScheduled',
                type: 'date',
                description: 'Timestamp of when the line item is scheduled to be fulfilled.'
            },
            {
                name: 'dateLastFulfilled',
                type: 'date',
                description: 'The most recent fulfillment date for a partially or completely fulfilled line item.'
            }
        ]
    },
    {
        name: 'customFields',
        type: 'list',
        description: 'A list of custom fields associated with the order.',
        children: [
            { name: 'id', type: 'integer', description: 'The custom field\'s unique identifier.' },
            { name: 'name', type: 'string', description: 'The name of the custom field.' },
            { name: 'value', type: 'string', description: 'The custom field\'s value.' },
            { name: 'type', type: 'string', description: 'The category of the custom field\'s value.' },
        ]
    },
];
